var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUidoLoad5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 333,
    viewBox: "0 0 235 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.383 99.8101C74.6834 99.8101 45.5834 122.2 40.7934 139.79C35.7634 158.28 71.8834 170.65 115.273 179.35L119.133 179.88C222.373 199.13 231.633 237.74 219.013 269.49",
    stroke: "#CC4429",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.062 330.72C139.862 330.72 157.772 324.75 158.342 315.95C158.832 308.3 144.822 299.66 116.002 296.08H115.272C44.5016 284.75 3.97156 257.18 1.60156 208.92",
    stroke: "#CC4429",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3913 155.97C18.3913 155.97 -8.05873 189.16 17.5513 208.36C43.1513 227.56 82.0713 235.82 144.561 251.82C184.481 263.11 200.991 290.56 188.021 306.74",
    stroke: "#CC4429",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3034 103.08C88.3034 103.08 63.7134 107.8 73.6434 115.88C81.7334 122.28 113.233 129.36 149.443 138.45C185.663 147.55 234.853 164.9 232.823 216.11",
    stroke: "#CC4429",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUidoLoad5);
export default __webpack_public_path__ + "static/media/uido_load_5.20f6fe6b5bae0fb747dfda5b9a17e6b8.svg";
export { ForwardRef as ReactComponent };